import { Text } from '@kluein/klue-ui';
import { Switch, Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ToggleFadedBoardsVisibilityProps = {
  boardsVisible: boolean;
  onToggleBoardsVisibility: () => void;
};

const ToggleFadedBoardsVisibility = ({
  boardsVisible,
  onToggleBoardsVisibility,
}: ToggleFadedBoardsVisibilityProps) => {
  const { t } = useTranslation('Dashboard');

  return (
    <Flex
      gap="sm"
      className="ask-klue-toggle-faded-boards-visibility"
      align="center"
      style={{
        position: 'absolute',
        bottom: '8px',
        right: boardsVisible ? '16px' : '75px', // make room for pendo icon in collapsed state
        cursor: 'pointer',
      }}
      onClick={onToggleBoardsVisibility}
    >
      <Text size="sm">{t('askKlue.toggleBoardsVisibility.toggle')}</Text>
      <Switch
        checked={boardsVisible}
        readOnly
        aria-label={t('askKlue.toggleBoardsVisibility.toggle')}
        style={{ pointerEvents: 'none' }}
      />
    </Flex>
  );
};

export default ToggleFadedBoardsVisibility;
